import { Section, SectionParagraph as Subtitle, SectionTitle as Title } from '@/components/shared/Content';
import { useSectionEventOnViewportEntrance } from '@/hooks/useSectionEventOnViewportEntrance';
import { Box, Flex, themedColor, useLottie, useViewportSize } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import React, { useRef } from 'react';
import styled from 'styled-components';
import lowMilagePpmLottieData from './assets/low_milage_ppm-lottie.json';
import lowMilagePpmMobileImage from './assets/milage/low_milage_mobile.svg';

const StyledSection = styled(Section)`
  background: linear-gradient(180deg, ${themedColor('cloud')} 0 84%, ${themedColor('white')} 17% 100%);

  @media only screen and (max-width: 767px) {
    background: linear-gradient(180deg, ${themedColor('cloud')} 0 85%, ${themedColor('white')} 17% 100%);
    height: 716px;
  }

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    background: linear-gradient(180deg, ${themedColor('cloud')} 0 86%, ${themedColor('white')} 17% 100%);
    height: 716px;
  }
`;

const LottieWrapper = styled(Box)`
  @media only screen and (min-width: 1651px) {
    height: 615px;
  }

  ${MEDIA_QUERIES.tablet`
        height: 320px;
    `}

  ${MEDIA_QUERIES.mobile`
        height: 300px;
    `}
`;

const GradientBox = styled.div`
  max-width: 941px;
  width: 100%;
  height: 320px;
  position: absolute;
  background: linear-gradient(rgb(247 247 247 / 100%), rgb(247 247 247 / 0%));
  z-index: 1;

  ${MEDIA_QUERIES.mobile`
        height: 200px;
    `}
`;

const Wrapper = styled(Flex)`
  @media only screen and (max-width: 1024px) {
    background-image: url(${lowMilagePpmMobileImage.src});
    width: 100%;
    height: 716px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
`;
export interface LowMilagePpmProps {
  title: string;
  subtitle: string;
}

const LowMilagePpm: React.FC<LowMilagePpmProps> = ({ title, subtitle }) => {
  const lottieRef = useRef<HTMLDivElement>(null);
  const { isBelowDesktopViewport } = useViewportSize();

  const intersectionRef = useSectionEventOnViewportEntrance({
    sectionName: 'lowMilagePpm',
    page: 'car',
  });

  useLottie(lottieRef, {
    animationData: lowMilagePpmLottieData,
    lottieConfig: {
      autoplay: true,
      loop: true,
      renderer: 'svg',
    },
  });

  return (
    <StyledSection
      mb={[50, 25]}
      pt={[50, 100]}
      pb={0}
      width="100%"
      position="relative"
      aria-label="auto insurance based on how much you drive"
      contain="paint"
      ref={intersectionRef}
    >
      <Wrapper flexDirection="column">
        <Flex
          flexDirection="column"
          alignItems="center"
          zIndex="2"
          width={[370, 1]}
          gap="20px"
          mb={[15, 0]}
          px={[25, 0, 0]}
          mx="auto"
        >
          <Title tabIndex={0}>{parse(title)}</Title>
          <Subtitle tabIndex={0}>{parse(subtitle)}</Subtitle>
        </Flex>
        <GradientBox />
        {!isBelowDesktopViewport && (
          <LottieWrapper mt={[0, '3px']} overflow="hidden">
            <Box ref={lottieRef} />
          </LottieWrapper>
        )}
      </Wrapper>
    </StyledSection>
  );
};

export default React.memo(LowMilagePpm);
